export default __webpack_public_path__ + "static/media/ic_cctv.fe3a8b08.png";